<template>
  <div style="margin: 20px 0">
    <div style="display:flex;justify-content:center">
      <div style="display:flex;justify-content:space-around">
        <div style="text-align:center">
          <img src="@/assets/images/claim/first_grey.png" v-if="step ==='1'" alt="">
          <img src="@/assets/images/claim/first.png" v-else alt="">
          <div>买家申请理赔</div>
        </div>
        <div style="margin-top:14px">
          <img class="img1" src="@/assets/images/refund/组 1614.png" alt="" />
        </div>
      </div>
      <!-- <div style="text-align:center">
        <img src="@/assets/images/claim/second.png" alt="">
        <div>买家处理理赔</div>
      </div> -->
      <div style="display:flex;justify-content:space-around">
        <div style="text-align:center">
          <img src="@/assets/images/claim/second_grey.png" v-if="step ==='2' || step ==='1'" alt="">
          <img src="@/assets/images/claim/second.png" v-else alt="">
          <div>卖家处理申请理赔</div>
        </div>
        <div style="margin-top:14px">
          <img class="img1" src="@/assets/images/refund/组 1614.png" alt="" />
        </div>
      </div>
      <div style="text-align:center">
        <img src="@/assets/images/claim/finish_grey.png" v-if="step ==='2' || step ==='1' || step === '3'" alt="">
        <img src="@/assets/images/claim/finish.png" v-else alt="">
        <div>理赔完成</div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    step: {
      default: '0',
      type: String
    }
  },
  data() {
    return {

    }
  },
  created() {
    console.log('wolaile!');
  }
}
</script>
<style lang="less" scoped>

</style>